import { Component, Input } from '@angular/core';
import { UITheme } from '../../../../../shared/definitions/ui-theme.enum';

@Component({
  selector: 'user-message',
  standalone: false,
  templateUrl: './user-message.component.html',
  styleUrls: ['./user-message.component.scss'],
  host: {
    class: 'angular-component-wrapper',
  },
})
export class UserMessageComponent {
  @Input() message: string = null;
  @Input() displayIcon: boolean = true;
  @Input() theme: UITheme;
}
